module.exports = __webpack_public_path__ + "2e0e65e693ffe0cc755519b5809b69d2.svg";